(function () {
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function setTab(dlg, id) {
    $$('.cv-dialog__tab', dlg).forEach(function (b) { b.setAttribute('aria-selected', b.dataset.tab === id ? 'true' : 'false'); });
    $$('[data-tab-panel]', dlg).forEach(function (p) { p.hidden = p.dataset.tabPanel !== id; });
  }

  var RING = [[49.3, '5'], [51.9, '6'], [54.4, '7'], [57.0, '8'], [59.5, '9'], [62.1, '10'], [64.6, '11'], [67.2, '12']];
  function wristToLength(cm) { if (cm <= 14) return '15 cm'; if (cm <= 16) return '18 cm'; if (cm <= 18) return '20 cm'; return null; }
  function ringToSize(mm) { for (var i = 0; i < RING.length; i++) { if (mm <= RING[i][0] + 0.6) return RING[i][1]; } return null; }

  function pickVariant(val) {
    var input = $$('variant-selects input[type=radio]').filter(function (i) { return i.value.trim().toLowerCase() === String(val).toLowerCase(); })[0];
    if (input && !input.checked) input.click();
    return !!input;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var open = t.closest('[data-cv-open]');
    if (open) {
      var d = document.getElementById(open.dataset.cvOpen);
      if (d && d.showModal) { if (open.dataset.cvTab) setTab(d, open.dataset.cvTab); d.showModal(); }
      return;
    }
    if (t.closest('[data-cv-close]')) { var dc = t.closest('dialog'); if (dc) dc.close(); return; }
    if (t.matches('dialog.cv-dialog')) { t.close(); return; }
    var dtab = t.closest('.cv-dialog__tab');
    if (dtab) { setTab(dtab.closest('dialog'), dtab.dataset.tab); return; }
    var tab = t.closest('.cv-tabs__tab');
    if (tab) {
      var root = tab.closest('.cv-tabs');
      $$('.cv-tabs__tab', root).forEach(function (b) { b.classList.toggle('is-active', b === tab); b.setAttribute('aria-selected', b === tab ? 'true' : 'false'); });
      $$('.cv-tabs__panel', root).forEach(function (p) { p.hidden = p.dataset.panel !== tab.dataset.tab; });
      return;
    }
    var calc = t.closest('[data-cv-calc]');
    if (calc) {
      var box = calc.closest('.cv-calc');
      var v = parseFloat(($('input', box).value || '').replace(',', '.'));
      var unitSel = $('select', box);
      var unit = unitSel ? unitSel.value : 'cm';
      var out = $('.cv-calc__out', box);
      if (!v) { out.textContent = 'Enter your measurement first.'; return; }
      var res;
      if (calc.dataset.cvCalc === 'ring') { if (unit === 'in') v = v * 25.4; res = ringToSize(v); }
      else { if (unit === 'in') v = v * 2.54; res = wristToLength(v); }
      if (!res) { out.textContent = 'That measurement is outside our standard sizes. Contact us and we will help you choose.'; return; }
      var picked = pickVariant(res);
      out.innerHTML = 'Recommended size: <strong>' + (calc.dataset.cvCalc === 'ring' ? 'US ' : '') + res + '</strong>' + (picked ? ' (selected for you)' : '');
    }
  });

  function addBiz(d, n) { d = new Date(d.getTime()); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
  function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  function eta() {
    $$('[data-cv-eta]').forEach(function (el) {
      var now = new Date();
      el.textContent = fmt(addBiz(now, +el.dataset.min || 8)) + ' – ' + fmt(addBiz(now, +el.dataset.max || 23));
    });
  }

  function sticky() {
    var bar = $('.cv-sticky');
    var btn = $('.product-form__submit');
    if (!bar || !btn || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    var priceEl = $('[data-cv-sticky-price]', bar);
    function syncPrice() {
      var p = $('.product__info-container .price--on-sale .price-item--sale') || $('.product__info-container .price-item--regular');
      if (p && priceEl) priceEl.textContent = p.textContent.trim();
    }
    new IntersectionObserver(function (en) {
      var e = en[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (show) syncPrice();
      bar.classList.toggle('is-visible', show);
    }).observe(btn);
    $('[data-cv-sticky-add]', bar).addEventListener('click', function () {
      var b = $('.product-form__submit');
      if (b && !b.disabled) b.click();
      else if (b) b.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function init() { eta(); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
